import React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

const GroupListTemp = Scrivito.connect(() => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    Comming soon...
  </div>
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    {/* <GroupList {...props} /> */}
    <GroupListTemp />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("GroupList", CheckedPage);
